var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 4 6.826 14 4 11.174",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export default SvgCheck;